module.exports = __webpack_public_path__ + "static/media/deleteDining.8f1d5cfb.svg";